import script from "./BurgerForm.vue?vue&type=script&setup=true&lang=js"
export * from "./BurgerForm.vue?vue&type=script&setup=true&lang=js"

import "./BurgerForm.vue?vue&type=style&index=0&id=507fb8ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-507fb8ea"]])

export default __exports__